module.exports = __webpack_public_path__ + "static/media/Galdisa_Crunchy & Spicy peanuts.f1ce776f.pdf";